import { Drawer } from '../../app/Drawer';
import { SettingsPage } from './SettingsPage';

/**
 * Editing your profile with your profile behind you.
 *
 * ## Why this one is a drawer
 *
 * Every control on the settings page changes something visible on a profile -
 * a picture, a header, a name, a bio, a row of links - and there is nothing
 * else on it. No password, no email, no account section. So the page you are
 * changing and the controls that change it can be on screen together, which is
 * the difference between picking a gradient and picking a gradient you can see.
 *
 * ## What "live" means here, exactly
 *
 * The picture and header pickers save the moment you click, and both invalidate
 * the profile query - so the page behind repaints under your cursor. The text
 * fields are a form with a Save button, so they land when you save it.
 *
 * That asymmetry is deliberate rather than unfinished. Piping unsaved
 * keystrokes into the page behind would render somebody's real profile showing
 * a bio they have not committed to, on the one page where they are least likely
 * to notice the difference.
 *
 * ## Only from your own profile
 *
 * The account menu still navigates. There is nothing behind it there worth
 * seeing, and a drawer over the dashboard would be a modal with extra steps.
 */
export function SettingsDrawer() {
  return (
    /*
     * A light scrim, unlike every other drawer.
     *
     * The page behind is the point here, not context to be pushed back - and a
     * 70% wash over a 2px blur makes judging a gradient or a picture
     * impossible, which is the one thing this arrangement exists to allow.
     */
    <Drawer title="Edit profile" fullPath="/settings" scrim="light">
      <SettingsPage inDrawer />
    </Drawer>
  );
}
